import { getEventNavigationData } from "~/lib/gtm/getGtmEventData";
import MenuItem, { IMenuItem } from "./MenuItem";
import MegaMenu from "./MegaMenu";
import { cn } from "~/lib/utils";

interface ItemsListProp {
    items: IMenuItem[] | undefined;
}

const ItemsList = ({
    items = [],
}: ItemsListProp) => {
    return items.map((item, idx: number) => {
        if (item.megaMenuChildren) {
            return (
                <MegaMenu
                    key={idx}
                    text={item.text}
                >
                    {item.megaMenuChildren}
                </MegaMenu>
            );
        }

        return (
            <MenuItem
                {...item}
                key={idx}
                className={cn(item.className)}
                gtmEventData={getEventNavigationData(item.text)}
            />
        );
    });
};

export default ItemsList;
